module.exports = __webpack_public_path__ + "media/images/resources/thumb_up-b67b60f56e98260dae3dfe354cfb1942.svg";